import { JobType, PositionLevel, WorkPlaceOptions } from "@utils/constants";

export interface Option<T = string> {
  label: string;
  value: T;
}

const toTitleCase = (value: string) =>
  value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const POSITION_LEVEL_OPTIONS: Option<number>[] = Object.entries(
  PositionLevel,
).map(([key, value]) => ({ label: toTitleCase(key), value }));

export const WORKPLACE_OPTIONS: Option<number>[] = WorkPlaceOptions;

export const JOB_TYPE_OPTIONS: Option<number>[] = JobType;

export const JOB_POST_DURATION_OPTIONS: Option<number>[] = [15, 30, 60].map(
  (days) => ({ label: `${days} days`, value: days }),
);

export const CURRENCY_OPTIONS: Option[] = [
  { label: "GBP (£)", value: "GBP" },
  { label: "EUR (€)", value: "EUR" },
  { label: "USD ($)", value: "USD" },
];

export const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: "£",
  EUR: "€",
  USD: "$",
};

export const COMPENSATION_TYPE_OPTIONS = [
  { label: "Annual salary", value: "annual_salary", unit: "per year" },
  { label: "Daily rate", value: "daily_rate", unit: "per day" },
  { label: "Hourly rate", value: "hourly_rate", unit: "per hour" },
] as const;

export const SKILL_IMPORTANCE_OPTIONS = ["Critical", "Important", "Preferred"];
export const SKILL_LEVEL_OPTIONS = [
  "Foundation",
  "Intermediate",
  "Advanced",
  "Expert",
];
export const SKILL_EXPERIENCE_OPTIONS = [
  "1+ years",
  "3+ years",
  "5+ years",
  "8+ years",
];
export const SKILL_RECENCY_OPTIONS = [
  "Current",
  "Within 2 years",
  "Within 5 years",
];

export const BELOW_THRESHOLD_OPTIONS: Option[] = [
  { label: "Keep in filtered candidates", value: "filtered" },
  { label: "Show at the end of the application list", value: "end_of_list" },
];

export const QUEUE_HEALTH_MINIMUM_OPTIONS: Option<number>[] = [3, 5, 10, 25].map(
  (count) => ({ label: String(count), value: count }),
);

export const findLabel = <T,>(options: Option<T>[], value: T) =>
  options.find((option) => option.value === value)?.label;
